/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */

import { CALL_API } from "../middleware";
import {
    GET_CURRENCY_INFO,
    GET_CURRENCY_INFO_SUCCESS,
    GetCurrencyInfoResponseBody,
    SET_CURRENCY_INFO
} from "../types/currencyInfo";

export const getCurrencyInfo =
    () =>
        async (dispatch: any): Promise<GetCurrencyInfoResponseBody> => {
            return await dispatch({
                [CALL_API]: {
                    url: '/onboarding/dashboard/get-currency',
                    method: 'GET',
                    types: [GET_CURRENCY_INFO_SUCCESS, GET_CURRENCY_INFO],
                },
            });
        };

export const setCurrencyInfo =
    (data: { locale: string; currencyCode: string; currencySymbol: string; }): { type: string; locale: string; currencyCode: string; currencySymbol: string; } => {
        return {
            type: SET_CURRENCY_INFO,
            locale: data?.locale ?? "en-IN",
            currencyCode: data?.currencyCode ?? "INR",
            currencySymbol: data?.currencySymbol ?? "20B9"
        };
    };



